import React from "react";
import { social } from "../mock";

// Real WhatsApp brand glyph (not an emoji).
function WhatsAppGlyph({ size = 30 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="currentColor" aria-hidden="true">
      <path d="M16.004 3C9.383 3 4 8.383 4 15.004c0 2.114.553 4.176 1.605 5.998L4 29l8.16-1.57a11.94 11.94 0 0 0 3.844.64h.001C22.621 28.07 28 22.688 28 16.067 28 12.86 26.75 9.85 24.48 7.58 22.21 5.31 19.21 3 16.004 3zm0 21.86h-.003a9.9 9.9 0 0 1-3.43-.62l-.246-.09-4.84.93.92-4.72-.16-.25a9.86 9.86 0 0 1-1.51-5.243c0-5.463 4.446-9.91 9.917-9.91 2.65 0 5.14 1.033 7.01 2.907a9.85 9.85 0 0 1 2.902 7.01c0 5.463-4.446 9.906-9.913 9.906zm5.44-7.42c-.298-.15-1.764-.87-2.038-.97-.273-.1-.472-.15-.67.15-.198.298-.767.968-.94 1.167-.173.198-.347.223-.644.075-.298-.15-1.258-.464-2.397-1.48-.886-.79-1.484-1.766-1.658-2.064-.173-.298-.018-.458.13-.606.134-.133.298-.347.447-.52.15-.174.198-.298.298-.497.099-.199.05-.372-.025-.521-.075-.149-.67-1.612-.918-2.208-.242-.58-.487-.5-.67-.51l-.57-.01c-.198 0-.52.074-.792.372-.273.298-1.04 1.016-1.04 2.479 0 1.462 1.065 2.876 1.213 3.074.149.198 2.095 3.2 5.076 4.487.71.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.764-.721 2.013-1.417.248-.695.248-1.29.173-1.417-.074-.124-.272-.198-.57-.347z" />
    </svg>
  );
}

export default function WhatsAppButton() {
  const href = `https://wa.me/${social.whatsapp}?text=${encodeURIComponent(
    "Hello K.S.E. Inc, I would like to know more about your garment manufacturing."
  )}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-6 right-6 z-[90] group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" />
      <span className="relative flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe57] text-white pl-4 pr-5 py-3.5 rounded-full shadow-2xl transition-all">
        <WhatsAppGlyph size={26} />
        <span className="hidden sm:block font-semibold text-sm max-w-0 overflow-hidden group-hover:max-w-[120px] transition-all duration-300 whitespace-nowrap">
          Chat with us
        </span>
      </span>
    </a>
  );
}
